import { render, staticRenderFns } from "./EmailOnboardingDomain.vue?vue&type=template&id=bdde27c0&scoped=true&"
import script from "./EmailOnboardingDomain.vue?vue&type=script&lang=js&"
export * from "./EmailOnboardingDomain.vue?vue&type=script&lang=js&"
import style0 from "./EmailOnboardingDomain.vue?vue&type=style&index=0&id=bdde27c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdde27c0",
  null
  
)

export default component.exports